import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const Essays = () => {
  const [essays, setEssays] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch essays from the API
    axios.get('https://backend.writerswright.com/api/v1/admin/getEssays')
      .then(response => {
        setEssays(response.data);
      })
      .catch(error => {
        console.error('There was an error fetching the essays!', error);
      });
  }, []);

  const navigateToAssignmentsDetails = (essayId) => {
    Cookies.set('essayId', essayId)
    navigate(`/admin-portal/assignments-details`);
  };

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3 alltitles">
        <h2 className='titleone'>Essays</h2>      
      </div>
      <div className='tables'>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Sr</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Essay</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Due Date</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Status</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Download</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Details</th>
            </tr>
          </thead>
          <tbody>
            {essays.map((essay, index) => (
              <tr key={essay.Id}>
                <td>{index + 1}</td>
                <td>{essay.Title}</td>
                <td>{new Date(essay.deadline).toLocaleString()}</td>
                <td>{essay.Status}</td>
                <td><a href={`https://backend.writerswright.com/${essay.document}`} style={{ color: "black" }}>Download Document</a></td>
                <td>
                  <button 
                    onClick={() => navigateToAssignmentsDetails(essay.Id)} 
                    style={{ color: "black", background: "none", border: "none", textDecoration: "underline" }}>
                    View More
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
}

export default Essays;
